var link = 'https://www.youtube.com/embed/{{ video_id }}';
var popup = `<div class="div-iframe-{{ block.id }} tw-fixed tw-flex tw-items-center tw-hidden tw-justify-center tw-top-0 tw-left-0 tw-size-full before:tw-bg-near-black before:tw-size-full before:tw-absolute before:tw-top-0 before:-tw-z-10 before:tw-left-0 before:tw-opacity-50 tw-z-20">
    <iframe
    id="ytplayer-{{ block.id }}"
    class="tw-z-10 tw-w-[90%] tw-h-3/4 md:tw-w-1/2 md:tw-h-1/2"
    type="text/html"
    width="640"
    height="360"
    allowfullscreen
    src="${link}"
    frameborder="0"></iframe>
</div>`;
var button = document.querySelector('#button-{{ block.id }}');
document.body.insertAdjacentHTML('beforeend', popup);
var div = document.querySelector('.div-iframe-{{ block.id }}');
var iframe = document.querySelector('#ytplayer-{{ block.id }}');

button.addEventListener('click', (e) => {
  div.classList.remove('tw-hidden');
});

div.addEventListener('click', (e) => {
  var iframeRect = iframe.getBoundingClientRect();
  if (
    e.clientX < iframeRect.left ||
    e.clientX > iframeRect.right ||
    e.clientY < iframeRect.top ||
    e.clientY > iframeRect.bottom
  ) {
    var iframeSrc = iframe.src;
    iframe.src = iframeSrc;
    div.classList.add('tw-hidden');
  }
});
